// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__QCRMb","paragraph":"style_paragraph__cgAUF"};